import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../ui/theme/colors';

export const useSettingsTreePanelStyles = makeStyles(() => ({
  grid: {
    flexGrow: 1
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    marginTop: '32px',
    minHeight: '100%'
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    borderBottom: `1px solid ${Colors.lightGray}`,
    marginBottom: '16px',
    height: '72px',
    padding: '16px 24px'
  }
}));
